import { Box, Stack, Typography } from "@mui/material";
import { matchPath, RouteObject, NavLink as RouterLink, useLocation, useMatch } from "react-router";
import { Link } from "@mui/material";
import { TLinkTab } from "./page-head-link-tabs";
import { link } from "fs";

interface ILinkTabsProps {
  links: TLinkTab[];
  parentPath?: string;
}

export const LinkTabs: React.FC<ILinkTabsProps> = (props) => {
  const { links, parentPath } = props;

  let activeLink = "";
  const { pathname } = useLocation();

  // matching paths to curr URL
  links.forEach((link) => {
    const _matchingPaths =
      (link.element.props as any).matchingPaths && (link.element.props as any).matchingPaths.length > 0
        ? [link.path, ...(link.element.props as any).matchingPaths]
        : [link.path];
    _matchingPaths.forEach((path) => {
      const pathString = path === "" ? `${parentPath}` : path.indexOf("/") === -1 ? `${parentPath}/${path}` : path;
      const _matchPath = matchPath(pathString, pathname);
      //@ts-expect-error
      if (_matchPath) activeLink = link.path;
    });
  });

  return (
    <Stack direction="row">
      {links.map((link, index) => (
        <LinkTab key={`link-${index}`} element={link.element} path={link.path} active={link.path === activeLink} />
      ))}
    </Stack>
  );
};

interface LinkTabProps {
  active?: boolean;
  path?: string;
}

const LinkTab: React.FC<LinkTabProps & TLinkTab> = (props) => {
  const { path = "#", element, active } = props;

  return (
    <Link
      to={path}
      end
      component={RouterLink}
      sx={(theme) => ({
        px: 1,
        py: 1,
        borderRadius: "6px",
        color: active ? theme.palette.primary.text : theme.palette.text.secondary,
        textDecoration: "none",
        fontWeight: active ? 500 : 400,
        "&:hover": {
          backgroundColor: !active ? theme.palette.backgroundAlpha.hover : "transparent",
          color: theme.palette.text.primary,
        },
        transition: theme.transitions.create(["background-color, color"], {
          duration: theme.transitions.duration.short,
          easing: theme.transitions.easing.easeOut,
        }),
        overflow: "hidden",
        textWrap: "nowrap",
        textOverflow: "ellipsis",
      })}
      variant="body1"
    >
      {(element.props as any).linkTitle}
    </Link>
  );
};
